export enum PPC_TABS {
  SUBSCRIPTIONS = 'Subscriptions',
  INVOICES = 'Invoices',
  REFUNDS = 'Refunds',
  SOLD_TO_ADDRESS = 'Sold-to address',
  SITE_URLS = 'Site URLs',
  CUSTOMER_CONTACTS = 'Customer Contacts',
  EMAILS = 'Emails',
  ORDERS = 'Orders',
  QUOTES = 'Quotes',
  BILLING_PROFILES = 'Billing Profiles',
  ORGANISATION = 'Organisation',
  SITES = 'Sites',
}
